import { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { Modal, Button, Col, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import MeetingCard from "./MeetingCard";
import { useAtom } from "jotai";
import { dealDetailsMeetingsAtom } from "jotai/DealJotaiInstance";

interface Meeting {
  id: string;
  meeting_name: string;
  meeting_start: string;
  meeting_end?: string;
  description?: string;
  location?: string;
  attendees?: string[];
  deal_id?: string;
}

const DealCalendar = () => {
  const [dealDetailsMeeting] = useAtom<Meeting[]>(dealDetailsMeetingsAtom);
  const [selectedEvent, setSelectedEvent] = useState<Meeting[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const highlightedDates = dealDetailsMeeting.map(
    (event) => new Date(event.meeting_start)
  );

  const handleDayClick = (date: Date) => {
    const selectedDate = date.toLocaleDateString("en-CA");

    const event = dealDetailsMeeting.filter((e) => {
      const meetingDate = new Date(e.meeting_start).toLocaleDateString("en-CA");
      return meetingDate === selectedDate;
    });

    if (event.length > 0) {
      setSelectedEvent(event);
      setModalOpen(true);
    }
  };

  return (
    <div id="lead-calendar">
      <h2 className="fs-6">Events</h2>

      <DayPicker
        mode="single"
        onDayClick={handleDayClick}
        modifiers={{ highlighted: highlightedDates }}
        modifiersStyles={{
          highlighted: {
            backgroundColor: "#96D9FF",
            color: "black",
          },
        }}
        style={{ overflow: "auto" }}
      />

      <Modal size="lg" show={isModalOpen} onHide={() => setModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Meetings Detail</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className="g-3">
            {selectedEvent.map((event: any) => (
              <Col xxl={6} key={event.id}>
                <MeetingCard meeting={event} />
              </Col>
            ))}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DealCalendar;
